import moment from "moment";

export const consentVerifier = (consent) => {
	return consent.privacy && consent.age && consent.vulnerability;
};
export const personalInformationVerifier = (application) => {
	let errors = {};
	const optionalFields = [
		"middleName",
		"lastNameAtBirth",
		"maidenName",
		"id",
		"idVerificationData",
		"id1AIVerificationData",
		"id2AIVerificationData",
	];
	Object.entries(application).forEach((entry) => {
		const [key, value] = entry;
		if (!value && !optionalFields.includes(key)) {
			errors = { ...errors, [key]: "This field is required" };
		}
	});
	if (!moment(application["birthDate"]).isValid()) errors = { ...errors, birthDate: "This field is required" };
	if (moment().diff(application["birthDate"], "years") < 18) errors = { ...errors, birthDate: "You need to be at least 18 years old" };
	return errors;
};
export const addressInformationVerifier = (address) => {
	let errors = {};
	const optionalFields = ["streetLine2", "dateMoveOut"];
	Object.entries(address).forEach((entry) => {
		const [key, value] = entry;
		if (!value && !optionalFields.includes(key)) {
			errors = { ...errors, [key]: "This field is required" };
		}
	});
	return errors;
};
export const addressListVerifier = (addresses) => {
	const errors = [];
	addresses.forEach((address, index) => {
		let addrErrors = {};
		const optionalFields = ["streetLine2", "dateMoveOut", "addressType"];
		Object.entries(address).forEach((entry) => {
			const [key, value] = entry;
			if (!value && !optionalFields.includes(key)) {
				addrErrors = { ...addrErrors, [key]: "This field is required" };
			}
		});
		if (address.dateMoveIn && !moment(address.dateMoveIn).isValid()) {
			addrErrors = { ...addrErrors, dateMoveIn: "Date format is invalid. Please use the format MMM DD YYYY. For example `Aug 15 2025`" };
		}
		if (address.dateMoveOut && !moment(address.dateMoveOut).isValid()) {
			addrErrors = { ...addrErrors, dateMoveOut: "Date format is invalid. Please use the format MMM DD YYYY. For example `Aug 15 2025`" };
		}

		errors[index] = Object.keys(addrErrors).length > 0 ? addrErrors : null;
	});

	return errors;
};
export const previousOffencesVerifier = (previousOffences) => {
	let errors = {};
	if (previousOffences)
		errors = {
			previousOffences:
				"If you have a previous offence please visit a police office to get your certificate. Unfortunately we cannot help you with an online certificate at this point. ",
		};
	if (previousOffences == null) errors = { previousOffences: "You must answer if you want to proceed" };

	return errors;
};

export const selfieVerifier = (selfie) => {
	let errors = {};
	if (!selfie) errors = { selfie: "You have to capture a photo to proceed" };

	return errors;
};
export const idVerifier = (id) => {
	let errors = {};
	if (!id.front) errors = { ...errors, front: "You have to upload the front of the identification document to proceed" };
	if (!id.back) errors = { ...errors, back: "You have to upload the back of the identification document to proceed" };

	return errors;
};
export const authorizationVerifier = (authorization) => {
	let errors = {};
	if (!authorization) errors = { authorization: "You must check this box to proceed" };
	return errors;
};
